import {Component, computed, inject, input, output} from "@angular/core";
import {Event, EventColors, EventState, EventType, ISimSession, TranslationKey, VMEvent} from "@models";
import {Translations} from "@translations";
import {TranslateService} from "@ngx-translate/core";
import {CustomColorMapping, SimEventPalette} from "../../models/SimEventPalette";

@Component({
	selector: "sim-event-status-widget",
	templateUrl: "./event-status-widget.component.html",
	styleUrl: "./event-status-widget.component.scss",
	standalone: false,
})
export class EventStatusWidgetComponent {
	//Signals
	public event = input.required<Event | (Event & VMEvent)>();
	public eventTooltip = computed<TranslationKey | null>(() => {
		switch (this.event().state) {
			case EventState.Active:
				return this.T.EVENT_DETAIL_ALREADY_RELEASED as TranslationKey;
			case EventState.Planned:
				return this.T.EVENT_DETAIL_NOT_RELEASED as TranslationKey;
			default:
				return null;
		}
	});

	// I/O
	public activeSession = input<ISimSession>();
	public variant = input<"horizontal" | "vertical">("vertical");
	public showDescription = input<boolean>(true);
	onClick = output<void>();

	// Injections
	public translate = inject(TranslateService);

	// Readonly
	protected readonly T = Translations;
	protected readonly EventState = EventState;
	protected readonly EventColors = EventColors;
	protected readonly EventType = EventType;
	protected readonly SimEventPalette = SimEventPalette;
	protected readonly EventColorMapping = CustomColorMapping;
}
